import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PhonelinkSetup from '@material-ui/icons/PhonelinkSetup';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleIcon from '@material-ui/icons/People'
import { connect } from 'react-redux';
import { IoIosShirt } from 'react-icons/io';
import { FaFileInvoiceDollar } from 'react-icons/fa';


import BatteryUnknown from '@material-ui/icons/BatteryUnknown'
import GroupWork from '@material-ui/icons/GroupWork'
import Dashboard from '@material-ui/icons/Dashboard'
import * as actionCreators from '../../actions/admin';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';



function mapStateToProps(state) {
  return {
    status: state.admin.currentView

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}



@connect(mapStateToProps, mapDispatchToProps)
class AdminDrawer extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      <div>
        <List>
          <ListItem button key='clients' onClick={this.props.switchAdminView}>
            <ListItemIcon><PeopleIcon /></ListItemIcon>
            <ListItemText primary='Clientes' />
          </ListItem>
          <ListItem button key='Productos' onClick={this.props.switchAdminView}>
            <ListItemIcon><IoIosShirt size={28}/></ListItemIcon>
            <ListItemText primary='Productos' />
          </ListItem>
          <ListItem button key='Logistica' onClick={this.props.switchAdminView}>
            <ListItemIcon><BatteryUnknown /></ListItemIcon>
            <ListItemText primary='Logistica' />
          </ListItem>
          <ListItem button key='Facturacion' onClick={this.props.switchAdminView}>
            <ListItemIcon><FaFileInvoiceDollar size={25}/></ListItemIcon>
            <ListItemText primary='Facturacion' />
          </ListItem>
          <ListItem button key='RRHH' onClick={this.props.switchAdminView}>
            <ListItemIcon><GroupWork /></ListItemIcon>
            <ListItemText primary='RRHH' />
          </ListItem>
          <ListItem button key='Dashboard' onClick={this.props.switchAdminView}>
            <ListItemIcon><Dashboard /></ListItemIcon>
            <ListItemText primary='Dashboard' />
          </ListItem>
        </List>
      </div>
    )
  }
}


AdminDrawer.propTypes = {
  switchAdminView: PropTypes.func,
};

export default AdminDrawer

// hacer up reducer/actions para admin:

// clients
// products
// stock
// rrhh


// WEBPACK FOOTER //
// ./src/components/Drawers/AdminDrawer.js